import {querySelectorArray} from "../utils/dom.utils";

export function initImageGalleries() {
    const galleries = querySelectorArray('.img-g');
    galleries.forEach(initImageGallery);
}

function hideImageMains() {
    let imgMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.img-g-main');
    imgMains.forEach(img => img.style.display = 'none');
}

function hideVideoMains() {
    let videoMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.video-main');
    videoMains.forEach(vid => vid.style.display = 'none');
}

function showImageMains() {
    let imgMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.img-g-main');
    imgMains.forEach(img => img.style.display = 'flex');
}

function showVideoMains() {
    let videoMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.video-main');
    videoMains.forEach(vid => vid.style.display = 'flex');
}

function initImageGallery<T extends HTMLElement>(el: T) {

    const thumbs = querySelectorArray(el, '.img-g-thumb');

    const setActiveImage = (thumb: HTMLElement) => {

        hideVideoMains();
        showImageMains();

        const img = thumb.querySelector('img');

        if (!img) return;

        thumbs.forEach(el => el.classList.remove('img-g-active'));
        let imgMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.img-g-main');

        imgMains.forEach(imgMain => {
            imgMain!.querySelector('img')!.src = img.src;
        });

        thumbs.forEach(el => el.classList.remove('img-g-active'));
        thumb.classList.add('img-g-active');
    }

    thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => setActiveImage(thumb));
    });
}

function setActiveVideo(youtubeUrl: string) {
    let embed = 'https://www.youtube.com/embed/';
    let videoId = youtubeUrl.split('/')[youtubeUrl.split('/').length - 1];
    embed = embed + videoId;

    hideImageMains();
    showVideoMains();

    let videoMains: HTMLDivElement[] = querySelectorArray<HTMLDivElement>('.video-main');
    videoMains.forEach(videoMain => {
        videoMain!.querySelector('iframe')!.src = embed;
    });
}

export function initVideos() {
    const videos = querySelectorArray('.video-thumb');

    if (!videos.length) return;

    videos.forEach((vid) => {
        vid.addEventListener('click', () => setActiveVideo(vid.getAttribute('data-src') || 'unknown'))
    })
}

